<template>
  <div>
    <el-dialog :title="changeHistoryData.title" :visible.sync="changeHistoryData.show" center width="1300px">
      <el-form inline :model="formData">
        <el-form-item :label="$t('transactionCurrency')">
          <el-select v-model="formData.Symbol" style="width: 150px" :placeholder="$t('transactionCurrency')" clearable>
            <el-option v-for="(item, index) in Symbols" :key="index" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('syncTime')">
          <el-date-picker style="width: 350px" v-model="formData.date" type="datetimerange" :range-separator="$t('To')" :start-placeholder="$t('startTime')"  :end-placeholder="$t('endTime')"> </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDataList">{{$t('Search')}}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" border v-loading="loading">
        <el-table-column type="index"  :label="$t('SerialNumber')" width="50px"></el-table-column>
        <el-table-column prop="PSymbol" :label="$t('PlatformCurrency')"></el-table-column>
        <el-table-column prop="Symbol" :label="$t('transactionCurrency')"></el-table-column>
        <el-table-column prop="CreateTime" width="150px" :label="$t('syncTime')"></el-table-column>
        <el-table-column prop="SynSource" :label="$t('exchangeRateSource')">
          <template slot-scope="scope">
            <span v-if="scope.row.SynSource == 1">{{$t('binance')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="RechargeRate" width="120px">
          <template slot="header">
            <el-tooltip effect="dark" placement="top">
              <div slot="content" style="text-align: center">充值即时汇率：交易币种 兑换 USDT 的兑换汇率</div>
              <div style="display: inline-block">
                <span style="margin-right: 5px">{{ $t('rechargeExchangeRate') }}</span>
                <span class="el-icon-question"></span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="RechargeFixType" width="160px">
          <template slot="header">
            <el-tooltip effect="dark" placement="top">
              <div slot="content" style="text-align: center">充值的话，为交易币种→平台币种，而交易的汇率是 平台币种:交易币种，<br />所以充值交易的汇率 = 即时汇率 + 偏差值</div>
              <div style="display: inline-block">
                <span style="margin-right: 5px">{{$t('rechargeExchangeRateDeviationRules')}}</span>
                <span class="el-icon-question"></span>
              </div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span v-if="scope.row.RechargeFixType == 1">{{ scope.row.RechargeFix }} {{ $t('Eigenvalue') }}</span>
            <span v-else>{{ scope.row.RechargeFix * 100 }}% {{ $t('percentage') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="RechargeFixValue" :label="$t('effectiveRechargeExchangeRate')" width="120px"></el-table-column>
        <el-table-column prop="WithwardRate" width="120px">
          <template slot="header">
            <el-tooltip effect="dark" placement="top">
              <div slot="content" style="text-align: center">提款即时汇率：USDT 兑换 交易币种 的兑换汇率</div>
              <div style="display: inline-block">
                <span style="margin-right: 5px">{{$t('withdrawalInstantExchangeRate')}}</span>
                <span class="el-icon-question"></span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="WithwardFixType" width="150px">
          <template slot="header">
            <el-tooltip effect="dark" placement="top">
              <div slot="content" style="text-align: center">提款的话，为平台币种→交易币种，而交易的汇率是 平台币种:交易币种，<br />所以提款交易的汇率 = 即时汇率 - 偏差值</div>
              <div style="display: inline-block">
                <span style="margin-right: 5px">{{$t('withdrawalExchangeRateDifferenceRules')}}</span>
                <span class="el-icon-question"></span>
              </div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span v-if="scope.row.WithwardFixType == 1">{{ scope.row.WithwardFix }} {{ $t('Eigenvalue') }}</span>
            <span v-else>{{ scope.row.WithwardFix * 100 }}% {{ $t('percentage') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="WithwardFixValue" :label="$t('effectiveWithdrawalExchangeRate')" width="120px"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total" @current-change="handleCurrentChange" :page-size="pagesize" :page-sizes="pagesizes" :current-page="current_row"> </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { app } from "@/api/app.js"
import base from "@/api/base.js"
export default {
  extends: base,
  props: {
    changeHistoryData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      formData: {
        Symbol: "",
        date: [new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0), new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59)],
      },
      tableData: [],
      loading: false,
      Symbols: [],
    }
  },
  created() {
    this.getSymbolList()
    this.getDataList()
  },
  methods: {
    //获取币种
    getSymbolList() {
      const data = {
        SellerId: this.filters.SellerId,
      }
      app.post("/pay/get_currency", data, (res) => {
        if (res.code == 200) {
          let arr = res.data.list || []
          this.Symbols = arr.map((item) => {
            return {
              value: item.Symbol,
              label: item.Symbol,
            }
          })
        }
      })
    },
    getDataList() {
      const data = {
        SellerId: this.filters.SellerId,
        Symbol: this.formData.Symbol,
        StartTime: this.formData.date ? app.getTimeStamp(this.formData.date[0]) : 0,
        EndTime: this.formData.date ? app.getTimeStamp(this.formData.date[1]) : 0,
        Page: this.page,
        PageSize: this.pagesize,
      }
      this.loading = true
      app.post("/pay/get_changelog", data, (res) => {
        if (res.code == 200) {
          this.tableData = res.data.data
          this.total = res.data.total
          this.tableData.forEach((item) => {
            item.CreateTime = this.$moment(item.CreateTime).format("YYYY-MM-DD HH:mm:ss")
            if (item.RechargeFixType == 1) {
              item.RechargeFixValue = (item.RechargeRate + item.RechargeFix).toFixed(3)
            } else {
              item.RechargeFixValue = (item.RechargeRate * (1 + item.RechargeFix)).toFixed(3)
            }
            if (item.WithwardFixType == 1) {
              item.WithwardFixValue = (item.WithwardRate - item.WithwardFix).toFixed(3)
            } else {
              item.WithwardFixValue = (item.RechargeRate * (1 - item.RechargeFix)).toFixed(3)
            }
          })
        }
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pagesize = val
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getDataList()
    },
  },
}
</script>

<style scoped></style>
